import React from 'react';
import { CustomFieldEntityType, CustomFieldUtil } from '../../../../../../types/custom_field';
import InnerFilterContent, { FilterInnerContentProps } from '../../../common/DropdownContent/DynamicFilterInnerContent';

export function CustomFieldEntityTypeFilterInnerContent({
  filter,
  filterProps,
  setFilterProps,
}: FilterInnerContentProps<CustomFieldEntityType>) {
  return (
    <InnerFilterContent
      filterProps={{ filterProps, setFilterProps }}
      filter={filter}
      items={[...(filterProps.customFieldEntityType || [])]}
      text={item => CustomFieldUtil.customFieldEntityTypeToString(item as CustomFieldEntityType)}
      onRemove={i => {
        filterProps.customFieldEntityType?.delete(i);
        if (!filterProps.customFieldEntityType?.size) filterProps.customFieldEntityType = undefined;
        setFilterProps({ ...filterProps });
      }}
    />
  );
}
